var map = {
	"./chocolate-fictional/material_component_information.json": [
		4629,
		[
			4629
		]
	],
	"./chocolate/material_component_information.json": [
		8993,
		[
			8993
		]
	],
	"./hemas-clogard/material_component_information.json": [
		1732,
		[
			1732
		]
	],
	"./linqOne/material_component_information.json": [
		4289,
		[
			4289
		]
	],
	"./munchee-tikiri-marie/material_component_information.json": [
		9844,
		[
			9844
		]
	],
	"./shan-teas/material_component_information.json": [
		2275,
		[
			2275
		]
	],
	"./wipotech-chocolates/material_component_information.json": [
		658,
		[
			658
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4460;
module.exports = webpackAsyncContext;